import { AuthLayout } from "../components/ui/auth-layout"
import { ResetPasswordForm } from "../components/auth/reset-password-form"

export default function ResetPasswordPage() {
  return (
    <AuthLayout title="Welcome Back" subtitle="Sign in to your VirtualScribe account" showBackButton={true}>
      <ResetPasswordForm />
    </AuthLayout>
  )
}
